export interface IFilterComboPropVerificacion {
  search: string;
  grupoVerificiacionId: string;
}
export const InitialFilterComboPropVerificacion = {
  search: "",
  grupoVerificiacionId: "",
};
export interface IPropiedadesPorGrupo {
  grupoName: string;
  propiedades: IPropiedades[];
}
export interface IPropiedades {
  key: string;
  text: string;
}
